
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Zap, Sun, BanknoteIcon, ArrowRight, ListTodo, Users, FileText } from "lucide-react";
import { motion } from "framer-motion";

const MainServiceCards = () => {
  const services = [
    {
      id: "solar",
      name: "Solar",
      title: "Transformação Energética",
      description: "Potencialize sua energia solar com soluções inteligentes",
      icon: <Sun className="h-5 w-5 text-amber-500" />,
      path: "/solar",
      color: "bg-amber-50 text-amber-700 border-amber-200",
      hoverColor: "hover:bg-amber-100"
    },
    {
      id: "energia",
      name: "Energia",
      title: "Comercialização",
      description: "Gestão de energia renovável",
      icon: <Zap className="h-5 w-5 text-blue-500" />,
      path: "/energia",
      color: "bg-blue-50 text-blue-700 border-blue-200",
      hoverColor: "hover:bg-blue-100"
    },
    {
      id: "financeiro",
      name: "Financeiro",
      title: "Gestão",
      description: "Faturamentos e pagamentos",
      icon: <BanknoteIcon className="h-5 w-5 text-green-500" />,
      path: "/financeiro",
      color: "bg-green-50 text-green-700 border-green-200",
      hoverColor: "hover:bg-green-100"
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
      {services.map((service, index) => (
        <motion.div
          key={service.id}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: index * 0.1 }}
        >
          <Card className={`${service.color} ${service.hoverColor} hover:shadow-md transition-all duration-300 transform hover:-translate-y-1 h-full`}>
            <CardContent className="flex flex-col items-center text-center p-4">
              <div className="p-2 rounded-full bg-white mb-2 shadow-sm">
                {service.icon}
              </div>
              <h3 className="font-medium text-base">{service.name}</h3>
              <div className="text-xs opacity-75 mt-1 mb-4">{service.title}</div>
              <p className="text-xs opacity-75 mb-4">{service.description}</p>
              <Button 
                asChild 
                variant="outline" 
                className={`w-full ${service.color.replace('bg-', 'border-')} ${service.hoverColor}`}
              >
                <Link to={service.path} className="flex justify-between items-center">
                  <span>Acessar {service.name}</span>
                  <ArrowRight className="h-4 w-4" />
                </Link>
              </Button>
            </CardContent>
          </Card>
        </motion.div>
      ))}
    </div>
  );
};

export default MainServiceCards;
